<template>
	<div>
		<van-form @submit="onSubmit">
			<van-row>
				<van-col span="24">
					<van-field
						v-model="mobile"
						name="用户名"
						label="用户手机号"
						placeholder="手机号码"
						:rules="[{ required: true, message: '请填写手机号码' }]"
				/></van-col>
			</van-row>
			<!--<van-row>
				<van-col span="24">
					<van-field
						v-model="verifyCode"
						name="验证码"
						label="验证码"
						placeholder="短信验证码"
						:rules="[{ required: true, message: '请填写验证码' }]"
					>
						<template #button>
							<van-button
								block
								type="info"
								@click="sendMobile"
								:disabled="btnMsg == null"
							>
								{{ btnMsg == null ? countNum + " s" : btnMsg }}
							</van-button>
						</template>
					</van-field>
				</van-col>
				<van-col span="8">
					<van-button
						block
						type="info"
						@click="sendMobile"
						:disabled="btnMsg == null"
					>
						{{ btnMsg == null ? countNum + " s" : btnMsg }}
					</van-button></van-col
				>
			</van-row>-->

			<van-row>
				<van-col span="18" offset="3" class="btn_register">
					<van-button block type="primary" native-type="submit">
						注册
					</van-button></van-col
				>
			</van-row>
		</van-form>
	</div>
</template>

<script>
import { Form, Button, Field, Row, Col, Toast } from "vant";
import { Post } from "@/utils/Api";

export default {
	components: {
		[Button.name]: Button,
		[Col.name]: Col,
		[Field.name]: Field,
		[Row.name]: Row,
		[Form.name]: Form,
		[Row.name]: Row,
	},
	data() {
		return {
			username: "",
			password: "",
			verifyCode: "",
			// 倒计时周期
			COUNT_MAX: 60,
			countNum: 60,
			// 用于倒计时标记，true-正在倒计时
			countFlag: false,
			// 定时器
			intervalBtn: {},
			//默认按钮的值
			btnMsg: "点击发送",
			//手机号码
			mobile: "",
		};
	},
	created: function() {},
	mounted: function() {},
	methods: {
		onSubmit() {
			Post(
				"register",
				{
					phoneNumber: this.mobile,
					openId: localStorage.getItem("openId"),
					// code: this.verifyCode,
					code:888888,
				},
				(res) => {
					console.log(res.data);
					if (res.data.success) {
						this.$router.push({
							path: "/user",
						});
					} else {
						Toast.fail(res.data.msg);
					}
				},
				(res) => {
					console.log(res);
				}
			);
		},
		// 倒计时
		countDown() {
			// 设置btn倒计时时显示的信息
			this.btnMsg = null;
			// 更改btn状态
			this.countFlag = !this.countFlag;
			// 设置倒计时
			this.intervalBtn = setInterval(() => {
				if (this.countNum <= 0) {
					// 重置btn提示信息
					this.btnMsg = "点击发送";
					this.btnMsgDisabled = false;
					// 清除定时器
					clearInterval(this.intervalBtn);
					// 更改btn状态
					this.countFlag = !this.countFlag;
					// 重置倒计时状态
					this.countNum = this.COUNT_MAX;
				}
				// 倒计时
				this.countNum--;
			}, 1000);
		},
		sendMobile() {
			//获取输入手机号码
			let mobile = this.mobile;
			//正则校验手机号是否合法
			if (!/^1(3|4|5|7|8)\d{9}$/.test(mobile)) {
				alert("手机号错误");
				return;
			}

			Post(
				"sendVerifyCode",
				{
					phoneNumber: this.mobile,
				},
				(res) => {
					console.log(res);
				},
				(res) => {
					console.log(res);
				}
			);

			//触发定时器方法
			this.countDown();
		},
	},
};
</script>

<style scoped>
.btn_register {
	margin-top: 20px;
}
</style>
